export { TutorPrescriptionPage, type TutorPrescriptionPageProps } from "./TutorPrescriptionPage"
